import { describeApiError } from '~/types/apiErrors'
import {
  type AllauthAuthResponse,
  isMFAAuthenticatePending,
  isMFATrustPending,
} from '~/types/allauth'

interface C5PFetchOptions {
  ignoreStatusCodes?: number[]
}

export default defineNuxtPlugin(() => {
  const { clearUser } = useAuth()
  const toast = useToast()

  const api = $fetch.create({
    baseURL: `${useRuntimeConfig().public.apiBase}/api`,
    credentials: 'include',
    async onRequest({ options }) {
      options.headers.set('X-CSRFToken', getCSRFToken() || '')
    },
    async onResponseError({ response, options }) {
      // 404s are always silently ignored; callers can suppress additional codes via ignoreStatusCodes.
      const { ignoreStatusCodes = [] } = options as C5PFetchOptions
      const effectiveIgnoreCodes = [404, ...ignoreStatusCodes]

      if (effectiveIgnoreCodes.includes(response.status)) {
        return
      }

      if (response.status === 401) {
        // Do not redirect when a multi-step auth flow is still in progress.
        const body = response._data as AllauthAuthResponse
        const isMfaInProgress =
          isMFAAuthenticatePending(body) || isMFATrustPending(body)
        if (!isMfaInProgress) {
          clearUser()
          await navigateTo('/login', { replace: true })
        }
      } else {
        const description = describeApiError(response._data)
        toast.add({ title: 'Er ging iets mis.', description, color: 'error' })
      }
    },
  })

  return {
    provide: {
      api,
    },
  }
})
